import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://lgmeeuozhlbwtsbarroy.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnbWVldW96aGxid3RzYmFycm95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQyNTI5OTcsImV4cCI6MjA2OTgyODk5N30.xeiPgXgzL2uRtd4lkJiHL8weHrMIsB1mRsjnjqDL1ig'

if(SUPABASE_URL == 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY == '<ANON_KEY>' ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})